import { Injectable } from '@angular/core';
import { LMFilterBuilderComponent } from '@modal/filter-builder/lm-filter-builder.component';
import { Observable, Subject } from 'rxjs';
import { SohoMessageService, SohoModalDialogService } from 'ids-enterprise-ng';
import { FilterBuilderDialogResult } from '@utils/index';
import { LMFormatUtilService } from '@services/utils';

@Injectable()
export class LMFilterBuilderService {
  constructor(private sohoModalDialogService: SohoModalDialogService,
    private lmFormatUtilService: LMFormatUtilService,
    private sohoMessageService: SohoMessageService) {
  }

  public openBuilderDialog(busclass: string, fieldLookUpUrl: string, fieldSearchUrl: string,  lplValidationUrl: string, hasExistingCondition: boolean, includeAuditFields?: boolean): Observable<LMFilterBuilderResult> {
    let lmFilterBuilderComponentRef: LMFilterBuilderComponent;
    const returnQuery = new Subject<LMFilterBuilderResult>();

    const closeModalWith = (result, modal) => {
      if (result === FilterBuilderDialogResult.CONFIRMATION_CANCEL) {
        modal.close(true);
        returnQuery.next({ dialogResult: result, lplQuery: undefined, matchOption: lmFilterBuilderComponentRef.matchOption });
        returnQuery.complete();
      } else if (lmFilterBuilderComponentRef.validateFilterConditions()) {
        const lplQuery = this.convertFilterRowCriteria(lmFilterBuilderComponentRef.filterRows, lmFilterBuilderComponentRef.matchOption);
        modal.close(true);
        returnQuery.next({ dialogResult: result, lplQuery, matchOption: lmFilterBuilderComponentRef.matchOption });
        returnQuery.complete();
      }
    };

    // Create modal button
    const buttons = [
      {
        text: Soho.Locale.translate('Cancel'),
        click: (e, modal) => {
          closeModalWith(FilterBuilderDialogResult.CONFIRMATION_CANCEL, modal);
        },
        isDefault: false
      }
    ];

    if (hasExistingCondition) {
      buttons.push(
        {
          text: Soho.Locale.translate('Append'),
          click: (e, modal) => {
            closeModalWith(FilterBuilderDialogResult.CONFIRMATION_APPEND, modal);
          },
          isDefault: true
        },
        {
          text: Soho.Locale.translate('Overwrite'),
          click: (e, modal) => {
            closeModalWith(FilterBuilderDialogResult.CONFIRMATION_OVERWRITE, modal);
          },
          isDefault: false
        }
      );
    } else {
      buttons.push(
        {
          text: Soho.Locale.translate('Ok'),
          click: (e, modal) => {
            closeModalWith(FilterBuilderDialogResult.CONFIRMATION_OK, modal);
          },
          isDefault: true
        }
      );
    }

    this.sohoModalDialogService
      .modal(LMFilterBuilderComponent)
      .options({ fullsize: 'responsive' })
      .cssClass('lm-filter-builder')
      .title(this.lmFormatUtilService.formatMessage(Soho.Locale.translate('LplConditionBuilderTitle'), busclass))
      .buttons(buttons)
      .open()
      .apply((dialogComponent: LMFilterBuilderComponent) => {
        lmFilterBuilderComponentRef = dialogComponent;
        lmFilterBuilderComponentRef.businessClass = busclass;
        lmFilterBuilderComponentRef.lookupUrl = fieldLookUpUrl;
        lmFilterBuilderComponentRef.fieldSearchUrl = fieldSearchUrl;
        lmFilterBuilderComponentRef.lplValidationUrl = lplValidationUrl;
        lmFilterBuilderComponentRef.includeAuditFields = includeAuditFields;
      });

    return returnQuery.asObservable();
  }

  public convertFilterRowCriteria(filterRows: Array<FilterRow>, macthOption: string): string {
    let query = '';
    const rowSize: number = filterRows.length;
    let i = 0;

    query += '(';
    filterRows.forEach(filterRow => {
      i++;
      if (filterRow.condition === 'false') {
        query += '!';
      }

      query += filterRow.subject.text;

      if (filterRow.condition !== 'false') {
        query += ' ';
      }

      switch (filterRow.condition) {
        case 'equalTo':
          query += '= ';
          break;
        case 'notEqualTo':
          query += '!= ';
          break;
        case 'entered':
          query += 'entered';
          break;
        case 'notEntered':
          query += 'not entered';
          break;
        case 'greaterThan':
          query += '>';
          break;
        case 'greaterThanOrEqualTo':
          query += '>=';
          break;
        case 'lessThan':
          query += '<';
          break;
        case 'lessThanOrEqualTo':
          query += '<=';
          break;
        case 'exist':
          query += 'exists';
          break;
        case 'doesNotExist':
          query += 'not exists';
          break;
        case 'like':
          query += 'like';
          break;
      }

      if (filterRow.predicate.text.trim().length !== 0) {
        if (filterRow.literal && filterRow.subject.type !== 'NUMBER') {
          query += ` "${filterRow.predicate.text}"`;
        } else {
          query += ` ${filterRow.predicate.text}`;
        }

      }

      if (i !== rowSize) {
        query += ` ${macthOption} `;
      }
    });
    query += ')';

    return query;

  }

}
